export const LIFE = {
  nickname: 'PRODUCTS.LIFE.shortname',
  isHidden: true,
  lifeInsurance: true,
  icon: 'life'
};
